export const baseUrl = process.env.REACT_APP_SERVER_HOST;
export const flowKey = 'roadmap';
